import { render, staticRenderFns } from "./question.vue?vue&type=template&id=7404d52b&scoped=true"
import script from "./question.vue?vue&type=script&lang=js"
export * from "./question.vue?vue&type=script&lang=js"
import style0 from "./question.vue?vue&type=style&index=0&id=7404d52b&prod&lang=less&scoped=true"
import style1 from "./question.vue?vue&type=style&index=1&id=7404d52b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7404d52b",
  null
  
)

export default component.exports